import type { LeagueCandidateList, LeagueRoster, LeagueRosterInput } from "@tnp/contracts";
import { apiRequest } from "../../../../shared/lib/api";

const base = (leagueId: string, divisionId: string) => `/api/organizer/leagues/${encodeURIComponent(leagueId)}/divisions/${encodeURIComponent(divisionId)}`;
const headers = (token: string) => ({ Authorization: `Bearer ${token}` });
export function getLeagueRoster(token: string, leagueId: string, divisionId: string) {
  return apiRequest<LeagueRoster>(`${base(leagueId, divisionId)}/members`, { headers: headers(token) });
}
export function saveLeagueRoster(token: string, leagueId: string, divisionId: string, body: LeagueRosterInput) {
  return apiRequest<LeagueRoster>(`${base(leagueId, divisionId)}/members`, { method: "PUT", headers: headers(token), body: JSON.stringify(body) });
}
export function searchLeagueCandidates(token: string, leagueId: string, divisionId: string, search: string, offset: number) {
  const query = new URLSearchParams({ search, offset: String(offset) });
  return apiRequest<LeagueCandidateList>(`${base(leagueId, divisionId)}/candidates?${query}`, { headers: headers(token) });
}
